<template>
    <div class="project" v-if="isShow">
        <Commondtitle title="工程案例" />
        <div class="pr_team">
            <div class="pr_t_left">
                <div class="pr_t_l_img">
                    <img :src="IMGURL + firstArr[0].fprojectImg" alt="">
                </div>
            </div>
            <div class="pr_t_right">
                <p class="pr_t_r_title">
                    一家专注解决环保问题的综合性环保机构
                </p>
                <h4 class="pr_t_r_name">{{ firstArr[0].fprojectTitle }}</h4>
                <p class="pr_t_r_des" v-html="firstArr[0].fprojectContent"></p>
            </div>
        </div>
        <ul class="pr_ul">
            <li
                @click="showWindow(item)"
                v-for="(item,index) in dataArr"
                :key="index">
                <div class="pr_u_li_item">
                    <!--<div class="pr_u_li_left">-->
                        <!--<p v-html="item.fprojectContent"></p>-->
                        <!--<i></i>-->
                    <!--</div>-->
                    <div class="pr_u_li_img">
                        <img :src="IMGURL + item.fprojectImg" alt="">
                    </div>
                </div>
                <p class="pr_ul_p">{{ item.fprojectTitle }}</p>
            </li>
        </ul>
        <!--弹窗-->
        <el-dialog
                :title="windowObj.fprojectTitle"
                :visible.sync="boolwindow"
                width="940px">
            <div class="projectWindow">
                <div class="pro_left">
                    <img :src="IMGURL + windowObj.fprojectImg" alt="">
                </div>
                <div class="pro_right" v-html="windowObj.fprojectContent"></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import Commondtitle from '../Commondtitle'
    import axios from '../../assets/js/baseaxios'
    import baseUrl from '../../assets/js/baseUrl'
    export default {
        name: "project",
        data(){
            return{
                isShow: false,
                IMGURL: '',
                dataArr: [],
                firstArr: [], //第一个
                boolwindow: false,
                windowObj:{
                    fprojectImg: '',
                    fprojectTitle: '',
                    fprojectContent: '',
                }
            }
        },
        mounted(){
            this.IMGURL = baseUrl.IMG_URL
            this.getData()
        },
        methods:{
            getData(){
                axios.get(`/api/project?page=1&limit=40`).then(res=>{
                    if(res.data.success){
                        let items = res.data.items
                        this.firstArr = items.slice(0,1)
                        this.dataArr = items.slice(1)
                        this.isShow = true
                    }else{
                        this.$message.warning(res.data.msg)
                    }
                })
            },
            showWindow(val){
                this.windowObj.fprojectImg = val.fprojectImg
                this.windowObj.fprojectTitle = val.fprojectTitle
                this.windowObj.fprojectContent = val.fprojectContent
                this.boolwindow = true
            }
        },
        components:{
            Commondtitle
        }
    }
</script>

<style scoped>
    .project{
        width: 100%;
    }
    .project .pr_team{
        position: relative;
        width: 1100px;
        height: 430px;
        margin: 0 auto 80px;
    }
    .pr_team .pr_t_left{
        position: absolute;
        left: 0;
        top: 0;
        width: 750px;
        height: 430px;
        background-color: rgba(0,183,107,.6);
        z-index: 1;
    }
    .pr_team .pr_t_left .pr_t_l_img{
        display: block;
        width: 550px;
        height: 430px;
        position: relative;
        overflow: hidden;
    }
    .pr_team .pr_t_left .pr_t_l_img img{
        position: absolute;
        left: 50%;
        height: 100%;
        transform: translateX(-50%);
    }
    .pr_team .pr_t_right{
        position: absolute;
        right: 0;
        top: 0;
        width: 351px;
        padding-right: 30px;
        text-align: right;
    }
    .pr_team .pr_t_right .pr_t_r_title{
        color: #00B76B;
        font-size: 14px;
        line-height: 19px;
        padding-top: 50px;
    }
    .pr_team .pr_t_right .pr_t_r_name{
        color: #333;
        font-size: 30px;
        line-height: 40px;
        padding: 24px 0 64px;
    }
    .pr_team .pr_t_right .pr_t_r_des{
        font-size: 14px;
        color: #999;
        line-height: 19px;
    }
    .pr_ul{
        width: 1100px;
        margin: 0 auto 54px;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }
    .pr_ul li{
        width: 330px;
        height: 263px;
        overflow: hidden;
        margin-bottom: 46px;
        margin-right: 55px;
        overflow: hidden;
    }
    .pr_ul li:nth-child(3n){
        margin-right: 0;
    }
    .pr_ul li .pr_u_li_item{
        position: relative;
        width: 330px;
        height: 220px;
        margin-bottom: 24px;
        /*transform: translateX(-140px);*/
        transition: .3s;
    }
    .pr_u_li_item::after{
        display: none;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255,255,255,.2);
    }
    /*.pr_ul li:hover .pr_u_li_item{*/
        /*transform: translateX(0);*/
    /*}*/
    .pr_ul li:hover .pr_u_li_item::after{
        display: block;
    }
    /*.pr_u_li_item .pr_u_li_left{*/
        /*float: left;*/
        /*width: 140px;*/
        /*height: 220px;*/
        /*padding: 16px 10px 16px 16px;*/
        /*box-sizing: border-box;*/
        /*background-color: #00B76B;*/
        /*position: relative;*/
    /*}*/
    /*.pr_u_li_item .pr_u_li_left p{*/
        /*height: 160px;*/
        /*width: 100%;*/
        /*font-size: 12px;*/
        /*color: #fff;*/
        /*line-height: 16px;*/
        /*overflow-y: auto;*/
        /*overflow-x: hidden;*/
    /*}*/
    /*.pr_u_li_item .pr_u_li_left i{*/
        /*position: absolute;*/
        /*top:180px;*/
        /*left: 16px;*/
        /*bottom:40px;*/
        /*width: 24px;*/
        /*height: 24px;*/
        /*background: url("../../assets/images/icon-construction.png") no-repeat center/24px 24px;*/
    /*}*/
    .pr_u_li_item .pr_u_li_img{
        /*float: left;*/
        display: block;
        width: 330px;
        height: 220px;
        overflow: hidden;
        position: relative;
    }
    .pr_u_li_item .pr_u_li_img img{
        position: absolute;
        width: 100%;
        top: 50%;
        transform: translateY(-50%);
    }
    .pr_ul .pr_ul_p{
        font-size: 16px;
        color: #333;
        line-height: 19px;
    }
    .projectWindow{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
    }
    .projectWindow .pro_left{
        width: 400px;
        height: 300px;
        position: relative;
        overflow: hidden;
    }
    .projectWindow .pro_left img{
        position: absolute;
        width: 100%;
        top: 50%;
        transform: translateY(-50%);
    }
    .projectWindow .pro_right{
        width: 490px;
        padding-left: 10px;
    }
</style>